import {
  EmploymentDuration,
  EmploymentPosition,
  EmploymentPositionLevel,
  EmploymentType
} from "./employee";

export enum JobPostingStatus {
  POSTED = "POSTED",
  UNPOSTED = "UNPOSTED",
  DRAFT = "DRAFT"
}

export enum JobPreferredStartDate {
  IMMEDIATELY = "IMMEDIATELY",
  WITHIN_TWO_WEEKS = "WITHIN_TWO_WEEKS",
  WITHIN_A_MONTH = "WITHIN_A_MONTH",
  FLEXIBLE = "FLEXIBLE"
}

export enum CurrencyCode {
  RWF = "RWF"
}

export interface Job {
  id: string;
  title: string;
  briefText: string;
  description: string;
  postingDate: string;
  lastUpdateDate: string;
  totalPay: number;
  postingStatus: JobPostingStatus;
  jobLocation: string;
  jobImage: string;
  hiringManager: string;
  jobRole: EmploymentPosition;
  jobLevel: EmploymentPositionLevel;
  jobType: EmploymentType;
  duration: EmploymentDuration;
  lastUpdatedBy: string;
  preferredStartDate: JobPreferredStartDate;
  currencyCode: CurrencyCode;
}

export interface getJobListResponse {
  getAllJobsWithFilter: Job[];
}

export interface getAllJobsResponse {
  getAllJobs: Job[];
}

export interface getJobByIdResponse {
  getJobById: Job;
}

export interface JobFilter {
  jobRole?: EmploymentPosition[];
  duration?: EmploymentDuration[];
  jobLevel?: EmploymentPositionLevel;
}

export type JobRoleFilter = {
  [key in EmploymentPosition]: boolean;
};

export type JobDurationFilter = {
  [key in EmploymentDuration]: boolean;
};

export type JobLevelFilter = EmploymentPositionLevel | "";

export interface JobSearchRequest {
  jobRole?: EmploymentPosition[];
  duration?: EmploymentDuration[];
  jobLevel?: EmploymentPositionLevel;
}

export interface JobFormData {
  title: string;
  briefText: string;
  totalPay: number;
  postingStatus: JobPostingStatus;
  jobLocation: string;
  jobImage: string;
  hiringManager: string;
  jobRole: EmploymentPosition;
  jobLevel: EmploymentPositionLevel;
  jobType: EmploymentType;
  duration: EmploymentDuration;
  preferredStartDate: JobPreferredStartDate;
  currencyCode: CurrencyCode;
}

export interface UpdateJobFormData extends JobFormData {
  description?: File;
}

export interface CreateJobFormData extends JobFormData {
  description: File;
}

export interface CreateJobResponse {
  createJob: Job;
}

export interface UpdateJobResponse {
  updateJob: Job;
}

export interface UpdateApplicationVariable extends JobFormData {
  id: string;
}
